import { render } from "./Background.vue?vue&type=template&id=04f32e61&scoped=true"
import script from "./Background.vue?vue&type=script&lang=js"
export * from "./Background.vue?vue&type=script&lang=js"

import "./Background.vue?vue&type=style&index=0&id=04f32e61&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-04f32e61"

export default script